import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import tw from "tailwind-styled-components";
import Table from "../../Components/NewComponents/FloorRoom/Table";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
} from "../../Components/Styles/PageStyles";

const FloorRoom = () => {
  const { t, i18n } = useTranslation();

  const tableData = [
    {
      id: 1,
      floor: "1",
      noOfRoom: 2,
    },
    {
      id: 2,
      floor: "2",
      noOfRoom: 0,
    },
    {
      id: 3,
      floor: "3",
      noOfRoom: 25,
    },
    {
      id: 4,
      floor: "4",
      noOfRoom: 0,
    },
  ];

  return (
    <BoxContainer>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          Manage Floors/Flats
          <Underline />
        </BoxTitle>
      </BoxHead>

      <TableWrapper>
        <Table ApiData={tableData} />
      </TableWrapper>
    </BoxContainer>
  );
};

const TableWrapper = tw.h1`my-8 border  bg-white rounded-md `;

export default FloorRoom;
